import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ErrorComponent() {
  const location = useLocation();
  const { errorText } = location.state || {};
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4">
      {/* Error icon or image */}
      <div className="w-20 h-20 mx-auto flex items-center justify-center">
        <img
          src="/Danger_Circle_Red.svg"
          alt={t("errorIconAlt")}
          className="image-container"
        />
      </div>

      <h2 className="error-title mx-auto">{t("genericErrorTitle")}</h2>

      <p className="displayed-error-message mx-auto">
        {errorText ||
          t("genericErrorMessage")}{" "}
      </p>
    </div>
  );
}
